import { render, staticRenderFns } from "./panel-navbar.vue?vue&type=template&id=6bf50ea9&"
import script from "./panel-navbar.vue?vue&type=script&lang=ts&"
export * from "./panel-navbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports